/**
 * Trigger: tr_debtors_insert
 * Purpose: Update account balances when a debtor is inserted
 * Table: debtors
 * Event: AFTER INSERT
 */
export const TR_DEBTORS_INSERT = `
CREATE TRIGGER tr_debtors_insert
AFTER INSERT ON debtors FOR EACH ROW
BEGIN
  UPDATE account_balances
  SET debtors_amount = debtors_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id;

  INSERT OR IGNORE INTO account_daily_balances(account_id, currency_id, balance_date)
  VALUES (new.account_id, new.currency_id, new.debtor_date);

  INSERT OR IGNORE INTO account_activity_dates(account_id, activity_date)
  VALUES (new.account_id, new.debtor_date);

  UPDATE account_daily_balances
  SET debtors_amount = debtors_amount + new.amount
  WHERE account_id = new.account_id
    AND currency_id = new.currency_id
    AND balance_date = new.debtor_date;

  INSERT OR IGNORE INTO exchange_rates (rate_date, rate, currency_id)
  SELECT new.debtor_date, new.exchange_rate, new.currency_id
  WHERE new.exchange_rate > 0;
END;
`;
